'use client';

import { cx } from '@otter-ai/den-components';
import { useDesktop } from '@otter-ai/desktop';
import {
  AccountSettingsNav,
  usePrefetchAccountSettingsNavItems,
} from './AccountSettingsNav';

export function AccountSettingsHeader() {
  usePrefetchAccountSettingsNavItems();
  const { supportsDesktopRedesign } = useDesktop();
  return (
    /* Account Settings Header has a minimum width of 700px, below which it will scroll horizontally */
    <header
      className={cx(
        'w-full overflow-x-auto min-w-0 otter-scrollbar mt-3',
        supportsDesktopRedesign ? 'shrink-0' : 'min-h-[48px]',
      )}
    >
      <div className="min-w-[700px] px-4">
        <AccountSettingsNav />
      </div>
    </header>
  );
}
